<template>
  <LayoutList
    :title="isAdmin ? 'Các bộ thẻ của ' + name : 'Danh sách bộ thẻ'"
    :learningResult="learningResult"
    :loading="loading"
    @goBrowse="handleGoBrowse"
    @onCardCreated="onCardCreated"
    @refresh="initListCardGroups"
    v-slot="slotParent"
  >
    <TableComponentV2
      :items="listCardGroups"
      :headers="$vuetify.breakpoint.smAndUp ? tableHeaders : tableHeadersMobile"
      @navigate="handleNavigateToLearnCard"
      @delete="handleDelete"
      @study="handleStudy"
      @rename="openDialogRenameProCardGroup"
      @randomStudy="handleRandomStudy"
      @reAssign="handleReAssign"
      @createNewGroupCard="showDialogCreateGroupCard = true"
      @createNewCard="handleAddCardForm(slotParent)"
      @showProCardGroups="handleShowProCardGroups"
      @openSetCountdownTimeModal="openSetCountdownTimeModal"
    />
    <div v-if="!isAdmin && totalPages > 1" class="page-select-wrap mt-2">
      <button
        class="page-nav-btn"
        :disabled="currentPage <= 1"
        @click="onPageChange(currentPage - 1)"
      >
        ‹
      </button>
      <select
        :value="currentPage"
        class="page-select"
        @change="onPageChange(Number($event.target.value))"
      >
        <option v-for="p in totalPages" :key="p" :value="p">
          Trang {{ p }} / {{ totalPages }}
        </option>
      </select>
      <button
        class="page-nav-btn"
        :disabled="currentPage >= totalPages"
        @click="onPageChange(currentPage + 1)"
      >
        ›
      </button>
    </div>

    <transition-group name="fade" v-if="$isProStudent">
      <template v-if="showDialogCreateProCard">
        <FormAddNewCard
          v-show="showAddForm"
          class="form-add small-screen"
          key="add"
          @minimize="showAddForm = false"
          @close="showDialogCancelAddCard = true"
          @onCardCreated="onCardCreated"
          @createNewCardGroup="handleCreateProGroupCard"
        />
      </template>
    </transition-group>
    <v-menu
      :set="(openActions = false)"
      v-if="
        $route.name !== 'manageStudentGroupCard' &&
        $vuetify.breakpoint.mdAndDown &&
        $isProStudent
      "
      v-model="openActions"
      offset-y
      transition="slide-y-transition"
      location="end"
    >
      <template v-slot:activator="{ attrs, on }">
        <div v-bind="attrs" v-on="on" class="menu-list-btn">
          <v-icon color="blue" class="cursor-pointer hover-scale icon"
            >mdi-plus-circle-outline</v-icon
          >
        </div>
      </template>
      <v-list class="pa-0 layout-list" style="min-width: 180px">
        <v-list-item
          class="px-5 py-1"
          link
          @click="showDialogCreateGroupCard = true"
        >
          <v-list-item-title class="d-flex align-center">
            <v-icon color="#3887FE" class="mr-2"
              >mdi-book-plus-multiple-outline</v-icon
            >
            Tạo bộ thẻ mới
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          class="px-5 py-1"
          link
          @click="handleAddCardForm(slotParent)"
        >
          <v-list-item-title class="d-flex align-center">
            <v-icon color="#1bb763" class="mr-2">mdi-card-plus-outline</v-icon>
            Tạo thẻ mới
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <DialogSetCountdownTime
      v-if="showDialogSetCountdownTime"
      :showDialogValue="showDialogSetCountdownTime"
      :countdownDataProp="countdownDataProp"
      :isFolder="editingGroupCard.isFolder"
      :currentUserGroupCardId="editingGroupCard.id"
      :currentUserFolder="
        editingGroupCard.isFolder
          ? editingGroupCard.currentUserFolder || editingGroupCard
          : null
      "
      @closeDialog="closeSetCountdownTimeModal"
      @confirmRequest="handleUpdateCountdownTime"
    />
    <DialogComponent
      v-if="$isProStudent && showDialogCreateGroupCard"
      typeDialog="student-create-card-group"
      :showDialogValue="showDialogCreateGroupCard"
      :itemsSelect="proFolderArrConst"
      @closeDialog="showDialogCreateGroupCard = false"
      @confirmRequest="handleCreateProGroupCard"
    />
    <DialogComponent
      v-if="$isProStudent && showDialogRenameGroupCard"
      typeDialog="student-rename-card-group"
      :showDialogValue="showDialogRenameGroupCard"
      :initialGroupName="deletingGroupCard.groupName"
      @closeDialog="showDialogRenameGroupCard = false"
      @confirmRequest="handleRenameProGroupCard"
    />
    <!-- <DialogComponent
      v-if="showConfirmCancelCreateCardGroup"
      typeDialog="confirm"
      :showDialogValue="showConfirmCancelCreateCardGroup"
      description="Bạn có thay đổi chưa lưu, bạn chắc chắn muốn huỷ tạo bộ thẻ Pro chứ?"
      @closeDialog="showConfirmCancelCreateCardGroup = false"
      @confirmRequest="handleCloseDialog"
    /> -->
    <DialogComponent
      v-if="showDialogDelete"
      typeDialog="confirm"
      :showDialogValue="showDialogDelete"
      @closeDialog="handleCloseDialog"
      @confirmRequest="
        $isProStudent ? handleDeleteProGroupCard() : handleUnassignGroupCard()
      "
    />
    <DialogComponent
      v-if="showDialogRemind"
      typeDialog="remind"
      :showDialogValue="showDialogRemind"
      @closeDialog="handleCloseDialog"
      :maxInputStudy="maxInputStudy"
      :isReviewAheadProFolder="isReviewAheadProFolder"
      :cardGroupsInProFolder="cardGroupsInProFolder"
    />
    <DialogComponent
      v-if="showDialogCustomRemind"
      typeDialog="customRemind"
      :showDialogValue="showDialogCustomRemind"
      @closeDialog="handleCloseDialog"
      @randomStudyCreated="onRandomStudyCreated"
      :maxInputStudy="maxInputStudy"
    />
    <DialogAssignCard
      v-if="isShowDialogAssign"
      :showDialogValue="isShowDialogAssign"
      :groupCardId="editingGroupCardId"
      @closeDialog="closeDialogAssign"
      :showSelect="false"
      :totalCards="assignMaxCards"
      :groupCard="editingGroupCard"
    />
    <DialogComponent
      v-if="showDialogCancelAddCard"
      :showDialogValue="showDialogCancelAddCard"
      typeDialog="confirm"
      description="Loại bỏ thay đổi và không tạo thẻ nữa?"
      @closeDialog="handleCloseDialog"
      @confirmRequest="handleCancelAddCard"
    />
  </LayoutList>
</template>

<script>
import LayoutList from "@/components/layout/LayoutList.vue";
import DialogComponent from "@/components/ui/DialogComponent.vue";
import DialogSetCountdownTime from "@/components/ui/DialogSetCountdownTime.vue";
import DialogAssignCard from "@/components/ui/DialogAssignCard.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import TableComponentV2 from "@/components/ui/TableComponentV2.vue";
import { getListMenuGroupCard } from "@/uttil/menu";
import { MENU_GROUP_CARD, RANDOM_STUDY_EMIT } from "@/constants/menu";
import {
  GROUP_CARD_TYPE_STORE_NAME,
  group_card_type,
} from "@/constants/groupcard";
import { setLocalStore } from "@/uttil/localStorage";
import {
  LIST_VIEW_TABLE_HEADERS,
  MOBILE_LIST_VIEW_TABLE_HEADERS,
  PRO_FOLDER_LIST,
} from "@/constants";
import FormAddNewCard from "../admin/FormAddNewCard.vue";
export default {
  name: "ListView",
  components: {
    DialogComponent,
    LayoutList,
    TableComponentV2,
    DialogAssignCard,
    FormAddNewCard,
    DialogSetCountdownTime,
  },
  data() {
    return {
      showDialogDelete: false,
      showDialogCreateGroupCard: false,
      showDialogSetCountdownTime: false,
      showDialogRenameGroupCard: false,
      showDialogCreateProCard: false,
      showDialogRemind: false,
      showDialogCustomRemind: false,
      tableHeaders: LIST_VIEW_TABLE_HEADERS,
      tableHeadersMobile: MOBILE_LIST_VIEW_TABLE_HEADERS,
      deletingGroupCard: "",
      maxInputStudy: 1,
      editingGroupCardId: "",
      isShowDialogAssign: false,
      assignMaxCards: 0,
      loading: true,
      editingGroupCard: {},
      proFolderArrConst: PRO_FOLDER_LIST,
      listCardGroups: [],
      showAddForm: false,
      showDialogCancelAddCard: false,
      folderIdAddingGroupCardTo: "",
      isReviewAheadProFolder: false,
      cardGroupsInProFolder: [],
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters("list", ["getListCardGroup"]),
    ...mapGetters("auth", ["getLoggedAccount"]),
    ...mapState("card", [
      "currentGroupCardId",
      "doneHomeWork",
      "isOpenPopUpHomeWork",
    ]),
    ...mapState("list", [
      "isLoading",
      "slotParentEventController",
      "newProCardGroupPayload",
      "pagination",
    ]),
    ...mapState("card", ["isReturnFromBrowseHistory"]),
    isListForProStudent() {
      return this.getListCardGroup?.proFolders?.length || this.$isProStudent;
    },
    isAdmin() {
      return this.$route.meta.role;
    },
    totalPages() {
      const { total, limit } = this.pagination;
      if (!total || !limit || limit >= 1000) return 0;
      return Math.ceil(total / limit);
    },
    studentId() {
      return this.$route.params.studentId;
    },
    name() {
      return this.getListCardGroup.fullName;
    },
    learningResult() {
      return this.getListCardGroup.learningResult;
    },
    countdownDataProp() {
      return this.editingGroupCard.countDown;
    },
  },
  watch: {
    slotParentEventController() {
      this.handleCreateProGroupCard(this.newProCardGroupPayload);
    },
  },
  async mounted() {
    this.loading = true;
    this.currentPage = this.isAdmin ? 1 : parseInt(this.$route.query.page) || 1;
    this.SET_CURRENT_CARD({ id: 0 });
    this.fetchTimeStudy({
      studentId: this.studentId,
      role: this.isAdmin,
      force: true,
    });
    await this.fetchStudentCardGroupList({
      studentId: this.studentId,
      page: this.currentPage,
      ...(this.isAdmin && { limit: 10000 }),
    });
    await this.setTypeLearn(-1);
    // Tắt overlay trước initListCardGroups (có thể nặng); nếu không, main thread
    // bận đến cuối mounted nên vẫn thấy spinner dù request đã xong trong Network.
    this.loading = false;
    await this.$nextTick();
    this.initListCardGroups();
    this.SET_DONE_HOME_WORK(
      this.getListCardGroup.isCompleteHomeWork && !this.isOpenPopUpHomeWork
    );
    if (this.isReturnFromBrowseHistory && this.$isProStudent) {
      this.showDialogCreateProCard = true;
      this.showAddForm = true;
    }
  },
  methods: {
    ...mapMutations("card", [
      "SET_CURRENT_GROUP_CARD_ID",
      "SET_PREVIOUS_CARD_ID",
      "SET_SHOW_SUCCESS",
      "SET_NEXT_CARD",
      "SET_NUM_NEW_CARDS_LEARNING",
      "SET_NUM_NEW_CARDS_WHEN_STARTING_LEARNING",
      "SET_NUM_RVS_CARDS_LEARNING",
      "SET_NUM_RVS_CARDS_WHEN_STARTING_LEARNING",
      "SET_CURRENT_LEARNING_GROUP_CARD_TITLE",
      "SET_CURRENT_CARD",
      "SET_DONE_HOME_WORK",
      "SET_IS_OPEN_POP_UP_HOME_WORK",
    ]),
    ...mapActions("list", [
      "fetchStudentCardGroupList",
      "unassignGroupCard",
      "deleteRandomStudy",
      "fetchTimeStudy",
    ]),
    ...mapActions("card", ["setTypeLearn"]),
    ...mapActions("student", [
      "studentCreateProCardGroup",
      "studentDeleteProGroupCard",
      "updateProCardSet",
      "updateCountdownTime",
      "updateFolderCountdownTime",
    ]),
    ...mapMutations("list", ["SET_LEARN_RETURN_PAGE"]),
    ...mapMutations("common", ["SET_DIALOG"]),
    filterRandomStudyAction(actions, item) {
      if (item?.allowRandomReview) return actions;
      return actions.filter(
        (action) => action.emitFunction !== RANDOM_STUDY_EMIT
      );
    },
    initListCardGroups() {
      const cardGroups = this.getListCardGroup?.cardGroups || [];
      const cardGroupRows = cardGroups.map((item) => {
        if (item?.id) {
          return {
            ...item,
            actions: this.filterRandomStudyAction(
              getListMenuGroupCard(item.type, MENU_GROUP_CARD),
              item
            ),
            showMenu: false,
          };
        }
      });
      if (!this.isListForProStudent) {
        this.listCardGroups = cardGroupRows;
        return;
      } else {
        const proFolders = this.getListCardGroup?.proFolders || [];
        const proFolderRows = proFolders
          .filter((folder) => folder.cardGroups?.length > 0)
          .map((folder) => {
            const proCardGroups = folder.cardGroups.map((group) => {
              return {
                ...group,
                actions: this.filterRandomStudyAction(
                  getListMenuGroupCard(
                    this.$isProStudent
                      ? group_card_type.PRO_GROUP_CARD
                      : group_card_type.PRO_GROUP_CARD_FOR_OLD_PRO_STUDENT,
                    MENU_GROUP_CARD
                  ),
                  group
                ),
                showMenu: false,
                isProGroupCard: true,
                parentFolder: folder,
              };
            });
            const isShowMenu =
              (this.listCardGroups.find(
                (row) => row.isFolder && row?.folderId === folder.folderId
              )?.showMenu ??
                true) ||
              folder.folderId === this.folderIdAddingGroupCardTo;
            return {
              ...folder,
              actions: getListMenuGroupCard(
                group_card_type.FOLDER,
                MENU_GROUP_CARD
              ),
              cardGroups: proCardGroups,
              showMenu: isShowMenu,
              isFolder: true,
            };
          });
        const combinedArray = proFolderRows.concat(cardGroupRows);
        this.listCardGroups = combinedArray || [];

        // keep folder opening after refresh
        this.proFolderArrConst.forEach((proFolderConst) => {
          const proFolderData = this.listCardGroups.find(
            (row) => row.isFolder && row.folderId === proFolderConst.folderId
          );
          if (proFolderData?.showMenu) {
            const indexOfProFolderInTable = this.listCardGroups.findIndex(
              (row) => row.isFolder && proFolderConst.folderId === row.folderId
            );
            this.listCardGroups.splice(
              indexOfProFolderInTable + 1,
              0,
              ...this.listCardGroups[indexOfProFolderInTable].cardGroups
            );
          }
        });
      }
    },
    openSetCountdownTimeModal(editingGroupCard) {
      this.showDialogSetCountdownTime = true;
      if (editingGroupCard.parentFolder) {
        this.editingGroupCard = {
          ...editingGroupCard,
          currentUserFolder: editingGroupCard.parentFolder,
        };
      } else {
        this.editingGroupCard = editingGroupCard;
      }
      console.log(this.editingGroupCard);
    },
    closeSetCountdownTimeModal() {
      this.showDialogSetCountdownTime = false;
      this.editingGroupCard = {};
    },
    async handleUpdateCountdownTime(payload) {
      this.loading = true;
      if (this.editingGroupCard.isFolder) {
        await this.updateFolderCountdownTime({
          folderId: this.editingGroupCard.folderId,
          countDownTime: +payload.time,
          showCountDown: payload.show,
        });
      } else {
        await this.updateCountdownTime({
          countDownTime: +payload.time,
          showCountDown: payload.show,
          userGroupCardIds: payload.appliedGroupCardIds,
        });
      }
      await this.closeAllDialogAndRefresh();
      this.editingGroupCard = {};
      this.loading = false;
    },
    handleShowProCardGroups(index) {
      this.listCardGroups[index].showMenu =
        !this.listCardGroups[index].showMenu;
      if (this.listCardGroups[index].showMenu) {
        this.listCardGroups.splice(
          index + 1,
          0,
          ...this.listCardGroups[index].cardGroups
        );
      } else {
        this.listCardGroups.splice(
          index + 1,
          this.listCardGroups[index].cardGroups.length
        );
      }
    },
    handleNavigateToLearnCard(item) {
      if (!item.totalCards) {
        this.SET_DIALOG({
          description: "Không có thẻ nào!",
        });
        return;
      }
      if (!this.isAdmin && !this.isLoading) {
        this.SET_SHOW_SUCCESS(false);
        this.SET_NEXT_CARD({ id: 0 });
        this.SET_CURRENT_CARD({ id: 0 });
        this.SET_PREVIOUS_CARD_ID(null);
        this.SET_CURRENT_GROUP_CARD_ID(item.id || item.folderId);
        this.SET_NUM_NEW_CARDS_LEARNING(0);
        this.SET_NUM_NEW_CARDS_WHEN_STARTING_LEARNING(item.newCard);
        this.SET_NUM_RVS_CARDS_LEARNING(0);
        this.SET_NUM_RVS_CARDS_WHEN_STARTING_LEARNING(item.revisingCard);
        console.log(item);
        this.SET_CURRENT_LEARNING_GROUP_CARD_TITLE(
          item.groupName || item.folderName
        );
        this.SET_LEARN_RETURN_PAGE(this.currentPage);
        setLocalStore(GROUP_CARD_TYPE_STORE_NAME, item.type);
        if (item.isFolder) {
          const learningGroupCardIds = item.cardGroups
            .map((group) => group.id)
            .join(",");
          this.$router.push(
            `/learn-card/${this.studentId}/${item.folderId}?&learningGroupCardIds=${learningGroupCardIds}`
          );
        } else {
          const isOpenMenu = this.listCardGroups.some(
            (el) => !el.isFolder && el.showMenu
          );
          if (isOpenMenu) return;
          this.$router.push(`/learn-card/${this.studentId}/${item.id}`);
        }
      }
    },
    handleGoBrowse() {
      if (this.isAdmin) {
        this.$router.push(`/browse-admin/student/${this.studentId}`);
      } else this.$router.push(`/browse/${this.studentId}`);
    },
    async handleDelete(item) {
      this.showDialogDelete = true;
      if (this.isAdmin || this.$isProStudent) {
        this.deletingGroupCard = item;
      } else {
        this.SET_CURRENT_GROUP_CARD_ID(item.id);
      }
    },
    async openDialogRenameProCardGroup(item) {
      this.showDialogRenameGroupCard = true;
      this.deletingGroupCard = item;
    },
    async handleCreateProGroupCard(payload) {
      await this.studentCreateProCardGroup(payload);
      this.closeAllDialogAndRefresh();
      this.folderIdAddingGroupCardTo = payload.folderId;
    },
    async handleRenameProGroupCard(proGroupCard) {
      await this.updateProCardSet({
        cardSetId: this.deletingGroupCard.groupCardId,
        cardSetName: proGroupCard.groupName,
        folderId: proGroupCard.folderId,
      });
      this.closeAllDialogAndRefresh();
      this.deletingGroupCard = null;
    },
    async onCardCreated() {
      this.SET_DIALOG({
        description: "Thêm thành công",
        autoClose: true,
      });
      await this.closeAllDialogAndRefresh();
      this.SET_DIALOG(false);
    },
    async onPageChange(page) {
      window.scrollTo(0, 0);
      this.currentPage = page;
      this.loading = true;
      this.$router.replace({ query: { ...this.$route.query, page } });
      await this.fetchStudentCardGroupList({ studentId: this.studentId, page });
      this.initListCardGroups();
      this.loading = false;
    },
    async closeAllDialogAndRefresh() {
      this.handleCloseDialog();
      await this.fetchStudentCardGroupList({
        studentId: this.studentId,
        page: this.currentPage,
        ...(this.isAdmin && { limit: 10000 }),
      });
      this.initListCardGroups();
    },
    async handleUnassignGroupCard() {
      if (this.isAdmin) {
        await this.unassignGroupCard(this.deletingGroupCard.id);
        this.deletingGroupCard = "";
      } else {
        // Delete Clone group
        await this.deleteRandomStudy({
          studentId: this.studentId,
          userGroupCardId: this.currentGroupCardId,
        });
        this.SET_CURRENT_GROUP_CARD_ID("");
      }
      this.closeAllDialogAndRefresh();
    },
    async handleDeleteProGroupCard() {
      const isProGroupCard = this.deletingGroupCard.createdFor;
      let deletingId = this.deletingGroupCard.id;
      if (isProGroupCard) {
        deletingId = this.deletingGroupCard.groupCardId;
        await this.studentDeleteProGroupCard(deletingId);
      } else {
        await this.unassignGroupCard(deletingId);
      }
      this.deletingGroupCard = "";
      this.closeAllDialogAndRefresh();
    },
    handleStudy(item) {
      this.maxInputStudy = 3;
      this.SET_CURRENT_GROUP_CARD_ID(item.id);
      this.isReviewAheadProFolder = item.isFolder;
      this.cardGroupsInProFolder = item.cardGroups?.map(
        (item) => item.groupCardId
      );
      this.showDialogRemind = true;
    },
    handleRandomStudy(item) {
      const groupCardClone = this.listCardGroups.find(
        (row) => row.type == group_card_type.GROUP_CARD_CLONED_FROM_SAVED
      );
      if (groupCardClone) {
        this.SET_DIALOG({
          description:
            "Bạn đang có bộ ôn tập ngẫu nhiên. Hãy học hết hoặc xóa bộ đó trước khi tạo bộ mới.",
        });
        return;
      }
      const totalCard = item?.totalCards;
      if (!totalCard) {
        this.SET_DIALOG({
          description: "Bộ thẻ chưa có thẻ nào được giao để ôn tập!",
        });
        return;
      }
      this.maxInputStudy = totalCard;
      this.SET_CURRENT_GROUP_CARD_ID(item.id);
      this.showDialogCustomRemind = true;
    },
    async onRandomStudyCreated() {
      // Must close here: `loading` unmounts LayoutList's slot (and this dialog's
      // listeners) before DialogComponent can emit closeDialog.
      this.showDialogCustomRemind = false;
      // COPY group is pinned near top of page 1 — jump there so it is visible.
      this.currentPage = 1;
      if (!this.isAdmin) {
        this.$router.replace({ query: { ...this.$route.query, page: 1 } });
      }
      this.loading = true;
      await this.fetchStudentCardGroupList({
        studentId: this.studentId,
        page: 1,
        ...(this.isAdmin && { limit: 10000 }),
      });
      this.initListCardGroups();
      this.loading = false;
    },
    handleCloseDialog() {
      this.showDialogCustomRemind = false;
      this.showDialogRemind = false;
      this.showDialogDelete = false;
      this.showDialogCreateGroupCard = false;
      this.showDialogSetCountdownTime = false;
      this.showDialogRenameGroupCard = false;
      this.showDialogCancelAddCard = false;
    },
    handleReAssign(item) {
      this.editingGroupCardId = item.groupCardId;
      this.editingGroupCard = item;
      this.assignMaxCards = item.totalCards;
      this.isShowDialogAssign = true;
    },
    closeDialogAssign() {
      this.isShowDialogAssign = false;
      this.editingGroupCardId = "";
      this.editingGroupCard = {};
    },
    handleCloseDialogComplete() {
      this.SET_DONE_HOME_WORK(false);
      this.SET_IS_OPEN_POP_UP_HOME_WORK(true);
    },
    handleAddCardForm(slotParent) {
      if (this.$vuetify.breakpoint.lgAndUp) {
        slotParent.openAddCardForm();
        return;
      }
      if (!this.showDialogCreateProCard) {
        this.showDialogCreateProCard = true;
        this.showAddForm = true;
      } else {
        this.showAddForm = !this.showAddForm;
      }
    },
    handleCancelAddCard() {
      this.showAddForm = false;
      this.handleCloseDialog();
      this.showDialogCreateProCard = false;
    },
  },
  async activated() {
    this.loading = true;
    if (!this.isAdmin) {
      const urlPage = parseInt(this.$route.query.page);
      if (urlPage && urlPage !== this.currentPage) {
        this.currentPage = urlPage;
      }
    }
    this.fetchTimeStudy({
      studentId: this.studentId,
      role: this.isAdmin,
      force: true,
    });
    await this.fetchStudentCardGroupList({
      studentId: this.studentId,
      page: this.isAdmin ? 1 : this.currentPage,
      ...(this.isAdmin && { limit: 10000 }),
    });
    this.loading = false;
    await this.$nextTick();
    this.initListCardGroups();
    if (this.isReturnFromBrowseHistory && this.$isProStudent) {
      this.showDialogCreateProCard = true;
      this.showAddForm = true;
    }
  },
  // deactivated() {
  //   console.log("deactivated");
  // },
};
</script>

<style lang="scss" scoped>
.menu-list-btn {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  position: fixed;
  bottom: 60px;
  right: 30px;
  background-color: white;
  display: flex;
  justify-content: center;
  .icon {
    font-size: 60px;
  }
}
</style>
<style lang="scss">
.table-action {
  width: 100px;
}
.groupName span {
  margin-left: 8px;
}
.form-add {
  position: absolute !important;
  top: 80px;
  right: 50%;
  transform: translate(50%);
  z-index: 100;
  &.small-screen {
    width: 100%;
    top: 58px;
    border-radius: 0px;
    height: calc(100vh - 58px);
  }
}
.page-select-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}
.page-select {
  border: 1px solid #bdbdbd;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 14px;
  background: #fff;
  color: #333;
  cursor: pointer;
  outline: none;
  min-width: 140px;
  text-align: center;
  text-align-last: center;
  -webkit-text-align-last: center;
  /* iOS Safari: remove native appearance to allow centering */
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23666'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 28px;
}
.page-nav-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #bdbdbd;
  border-radius: 6px;
  background: #fff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #555;
  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}
.pagination-scroll-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  nav {
    width: max-content;
    min-width: 100%;
  }
  .v-pagination {
    flex-wrap: nowrap !important;
    width: max-content !important;
    min-width: 100%;
  }
}
</style>
